import Vue from "vue";
import Router from "vue-router";
import home from "../views/home.vue";
import login from "../views/login.vue";
import internstudentform from "../views/internstudentform.vue";
import store from "./../vuex/store";

import register from "../views/register.vue";
import userprofile from "../views/userprofile.vue";

import oapp from "../views/oapp/oapp-main.vue";
import oappreport from "../views/oapp/report.vue";
import oappdasmreport from "../views/oapp/dasmreport.vue";
import oappdasmplan from "../views/oapp/dasmplan.vue";
import oappdppreport from "../views/oapp/dppreport.vue";
import oappdppplan from "../views/oapp/dppplan.vue";
import oappmarketplan from "../views/oapp/marketplan.vue";
import oappmarketreport from "../views/oapp/marketreport.vue";
import oappsaleplan from "../views/oapp/saleplan.vue";
import oappsalereport from "../views/oapp/salereport.vue";

import dpp from "../views/dpp/dpp-main.vue";
import dppbranch from "../views/dpp/settingbranch.vue";
import dppfarmer from "../views/dpp/settingfarmer.vue";
import dppuser from "../views/dpp/settinguser.vue";

import dppoarecord from "../views/dpp/dppoarecord.vue";
import dppoaicsrecord from "../views/dpp/dppoaicsrecord.vue";
import dppoacerform from "../views/dpp/dppoacerform.vue";
import dppoatrainingcourse from "../views/dpp/dppoatrainingcourse.vue";
import dppoamanual from "../views/dpp/dppoamanual.vue";

import dppplantnoti from "../views/dpp/dppplantnoti.vue";
import dppharvestnoti from "../views/dpp/dppharvestnoti.vue";
import dppweathernoti from "../views/dpp/dppweathernoti.vue";
import dppgeneralnoti from "../views/dpp/dppgeneralnoti.vue";



import b2bcontractplan from "../views/dpp/b2bcontractplan.vue";
import b2bcontractplanprogress from "../views/dpp/b2bcontractplanprogress.vue";
import b2bcontractplanbranch from "../views/dpp/b2bcontractplanbranch.vue";
// import productionoffarmer from "../views/dpp/productionoffarmer.vue";





import dasm from "../views/dasm/dasm-main.vue";
import dasmbranch from "../views/dasm/settingdasmbranch.vue";
import dasmuser from "../views/dasm/settingdasmuser.vue";
import dasmb2buser from "../views/dasm/settingdasmb2buser.vue";
import dasmmarket from "../views/dasm/settingdasmmarket.vue";
import dasmshippingfee from "../views/dasm/settingdasmshippingfee.vue";
import dasmpurchaser from "../views/dasm/settingdasmpurchaser.vue";
import dasmproductbuyvender from "../views/dasm/settingdasmproductbuyvender.vue";
import marketquota from "../views/dasm/marketquota.vue";
import b2bcontractquota from "../views/dasm/b2bcontractquota.vue";
import b2bcontractquotapurchase from "../views/dasm/b2bcontractquotapurchase.vue";
import b2bcontractpurchasecustomer from "../views/dasm/b2bcontractpurchase-customer.vue";
import stockmanagement from "../views/stock/stockmanagement.vue";
import stockproductdailyprice from "../views/stock/stockproductdailyprice.vue";
import stockproductpurchase from "../views/stock/stockproductpurchase.vue";
import stockproductpurchasev2 from "../views/stock/stockproductpurchasev2.vue";
import checkstock from "../views/stock/stockcheck.vue";
import stockoutwait from "../views/stock/stockoutwait.vue";
import marketplan from "../views/dasm/marketplan.vue";
import marketplanbranch from "../views/dasm/marketplanbranch.vue";
import marketonline from "../views/dasm/marketonline.vue";
import preorder from "../views/dasm/preorder.vue";
import stockin from "../views/dasm/stockin.vue";
import stockout from "../views/dasm/stockout.vue";
import test from "../views/dasm/test.vue";
import dasmpaymentform from "../views/dasm/paymentform.vue";
import dasmb2breceipt from "../views/dasm/b2breceipt.vue";

import b2bcontractpurchasejoinbill from "../views/dasm/b2bcontractpurchase_joinbill.vue";
import b2bcontractpurchasemanagebill from "../views/dasm/b2bcontractpurchase_managebill.vue";
import b2bcontractpurchasewaiter from "../views/dasm/b2bcontractpurchase_waiter.vue";
import b2bcontractpurchaseprice from "../views/dasm/b2bcontractpurchase_price.vue";



import clinic from "../views/clinic/clinic-main.vue";
import clinicproductionreport from "../views/clinic/productionreport.vue";
import clinicb2bproductionreportbranchreport from "../views/clinic/b2bproductionbranchreport.vue";
import clinicsettingproduct from "../views/clinic/clinicsettingproduct.vue";
import clinicsettingstockproduct from "../views/clinic/clinicsettingstockproduct.vue";
import clinicsettingproductpricetype from "../views/clinic/clinicsettingproductpricetype.vue";
import clinicsettingproduct_data from "../views/clinic/clinicsettingproduct_data.vue";
import clinicuser from "../views/clinic/settingclinicuser.vue";
import clinicbranch from "../views/clinic/settingclinicbranch.vue";
import clinicbranchproductivity from "../views/clinic/clinicbranchproductivity.vue";
import clinicreportproductivity from "../views/clinic/clinicproductivityreport.vue";
import clinicallproductivityreport from "../views/clinic/clinicallproductivityreport.vue";
import clinicproductgroupbytypereport from "../views/clinic/clinicproductsgroupbytypereport.vue";

// import marketchecker from "../views/marketchecker/marketchecker-main.vue";
import marketcheckproduct from "../views/marketchecker/marketcheckproduct.vue";
import marketmanagercheckerproduct from "../views/marketmanager/marketcheckproduct.vue";
import marketmanagerrider from "../views/marketmanager/marketrider.vue";
import marketrecommendproduct from "../views/marketmanager/marketrecommendproduct.vue";


//ics 
import icsmain from "../views/ics/icsmain.vue";
import icsuser from "../views/ics/settingicsuser.vue";
import icsprovince from "../views/ics/settingprovince.vue";
import icsrecorddistrict from "../views/ics/icsrecorddistrict.vue";
import icsviolation from "../views/ics/icsviolation.vue";
import icscertification from "../views/ics/icscertification.vue";
import icsgroupcheckproduct from "../views/ics/icsgroupcheckproduct.vue";


import marketpurchaser from "../views/dasm/b2bmarketpurchaser.vue";
import marketpurchaserstatement from "../views/dasm/b2bmarketpurchaserstatement.vue";

import account from "../views/account/account.vue";
import accountmarket from "../views/account/accountMarket.vue";
import accountmarketcheck from "../views/account/accountMarketCheck.vue";
import accountstockmarketcheck from "../views/account/accountStockMarketCheck.vue";

import issue from "../views/issue/issue.vue";


Vue.use(Router);

const router = new Router({
  // mode: "history",
  routes: [{
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/internstudentform",
      name: "internstudentform",
      component: internstudentform
    },
    {
      path: "/register",
      name: "register",
      component: register
    },
    {
      path: "/",
      name: "home",
      component: home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: userprofile,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/oapp",
      name: "oapp",
      component: oapp,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/oapp/report",
      name: "oappreport",
      component: oappreport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/oapp/dasmreport",
      name: "oappdasmreport",
      component: oappdasmreport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/oapp/dasmplan",
      name: "oappdasmplan",
      component: oappdasmplan,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/oapp/dppreport",
      name: "oappdppreport",
      component: oappdppreport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/oapp/dppplan",
      name: "oappdppplan",
      component: oappdppplan,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/oapp/marketreport",
      name: "oappmarketreport",
      component: oappmarketreport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/oapp/marketplan",
      name: "oappmarketplan",
      component: oappmarketplan,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/oapp/salereport",
      name: "oappsalereport",
      component: oappsalereport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/oapp/saleplan",
      name: "oappsaleplan",
      component: oappsaleplan,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp",
      name: "dpp",
      component: dpp,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp/setting/branch",
      name: "dppbranch",
      component: dppbranch,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp/setting/farmer",
      name: "dppfarmer",
      component: dppfarmer,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp/setting/user",
      name: "dppuser",
      component: dppuser,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/marketplan",
      name: "marketplan",
      component: marketplan,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dasm/marketonline",
      name: "marketonline",
      component: marketonline,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/preorder",
      name: "preorder",
      component: preorder,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/stockin",
      name: "stockin",
      component: stockin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dasm/stockout",
      name: "stockout",
      component: stockout,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/paymentform",
      name: "dasmpaymentform",
      component: dasmpaymentform,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/b2breceipt",
      name: "dasmb2breceipt",
      component: dasmb2breceipt,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/test",
      name: "test",
      component: test,
      meta: {
        requiresAuth: true
      }
    },



    {
      path: "/dpp/oarecord",
      name: "dppoarecord",
      component: dppoarecord,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp/oaicsrecord",
      name: "dppoaicsrecord",
      component: dppoaicsrecord,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp/oacerform",
      name: "dppoacerform",
      component: dppoacerform,
      meta: {
        requiresAuth: true
      }
    },


    {
      path: "/dpp/oatrainingcourse",
      name: "dppoatrainingcourse",
      component: dppoatrainingcourse,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp/oamanual",
      name: "dppoamanual",
      component: dppoamanual,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp/b2bcontractplan",
      name: "b2bcontractplan",
      component: b2bcontractplan,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp/b2bcontractplanprogress",
      name: "b2bcontractplanprogress",
      component: b2bcontractplanprogress,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp/b2bcontractplanbranch",
      name: "b2bcontractplanbranch",
      component: b2bcontractplanbranch,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dpp/plantnoti",
      name: "dppplantnoti",
      component: dppplantnoti,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dpp/harvestnoti",
      name: "dppharvestnoti",
      component: dppharvestnoti,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dpp/weathernoti",
      name: "dppweathernoti",
      component: dppweathernoti,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dpp/generalnoti",
      name: "dppgeneralnoti",
      component: dppgeneralnoti,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: "/dpp/productionoffarmer",
    //   name: "productionoffarmer",
    //   component: productionoffarmer,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },

    {
      path: "/dasm/marketplanbranch",
      name: "marketplanbranch",
      component: marketplanbranch,
      meta: {
        requiresAuth: true
      }
    },

    // dasm

    {
      path: "/dasm",
      name: "dasm",
      component: dasm,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/setting/branch",
      name: "dasmbranch",
      component: dasmbranch,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dasm/setting/user",
      name: "dasmuser",
      component: dasmuser,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/setting/b2buser",
      name: "dasmb2buser",
      component: dasmb2buser,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/setting/market",
      name: "dasmmarket",
      component: dasmmarket,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/setting/shippingfee",
      name: "dasmshippingfee",
      component: dasmshippingfee,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dasm/setting/purchaser",
      name: "dasmpurchaser",
      component: dasmpurchaser,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dasm/setting/productbuyvender",
      name: "dasmproductbuyvender",
      component: dasmproductbuyvender,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dasm/marketquota",
      name: "marketquota",
      component: marketquota,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/b2bcontractquota",
      name: "b2bcontractquota",
      component: b2bcontractquota,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dasm/b2bcontractquotapurchase",
      name: "b2bcontractquotapurchase",
      component: b2bcontractquotapurchase,
      meta: {
        requiresAuth: true
      }
    },
    

    {
      path: "/dasm/b2bcontractpurchasejoinbill",
      name: "b2bcontractpurchasejoinbill",
      component: b2bcontractpurchasejoinbill,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/b2bcontractpurchasemanagebill",
      name: "b2bcontractpurchasemanagebill",
      component: b2bcontractpurchasemanagebill,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/b2bcontractpurchasewaiter",
      name: "b2bcontractpurchasewaiter",
      component: b2bcontractpurchasewaiter,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/b2bcontractpurchaseprice",
      name: "b2bcontractpurchaseprice",
      component: b2bcontractpurchaseprice,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/stock/stockproductpurchase",
      name: "stockproductpurchase",
      component: stockproductpurchase,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/stock/stockproductpurchasev2",
      name: "stockproductpurchasev2",
      component: stockproductpurchasev2,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/stock/checkstock",
      name: "checkstock",
      component: checkstock,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/stock/stockmanagement",
      name: "stockmanagement",
      component: stockmanagement,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/stock/stockproductdailyprice",
      name: "stockproductdailyprice",
      component: stockproductdailyprice,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/stock/stockoutwait",
      name: "stockoutwait",
      component: stockoutwait,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/dasm/b2bcontractpurchasecustomer",
      name: "b2bcontractpurchasecustomer",
      component: b2bcontractpurchasecustomer,
      meta: {
        requiresAuth: true
      }
    },


    // clinic

    {
      path: "/clinic",
      name: "clinic",
      component: clinic,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/clinic/productionreport",
      name: "clinicproductionreport",
      component: clinicproductionreport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/clinic/b2bproductionbranchreport",
      name: "clinicb2bproductionreportbranchreport",
      component: clinicb2bproductionreportbranchreport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/clinic/setting/product",
      name: "clinicsettingproduct",
      component: clinicsettingproduct,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/clinic/setting/stockproduct",
      name: "clinicsettingstockproduct",
      component: clinicsettingstockproduct,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/clinic/setting/productpricetype",
      name: "clinicsettingproductpricetype",
      component: clinicsettingproductpricetype,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/clinic/setting/product_data",
      name: "clinicsettingproduct_data",
      component: clinicsettingproduct_data,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/clinic/setting/user",
      name: "clinicuser",
      component: clinicuser,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/clinic/setting/branch",
      name: "clinicbranch",
      component: clinicbranch,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/clinic/branch/productivity",
      name: "clinicbranchproductivity",
      component: clinicbranchproductivity,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/clinic/report/productivity",
      name: "clinicreportproductivity",
      component: clinicreportproductivity,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/clinic/report/allproductivity",
      name: "clinicallproductivityreport",
      component: clinicallproductivityreport,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/clinic/report/productgroupbytype",
      name: "clinicproductgroupbytypereport",
      component: clinicproductgroupbytypereport,
      meta: {
        requiresAuth: true
      }
    },

    // marketchecker


    {
      path: "/marketchecker/marketcheckproduct",
      name: "marketcheckproduct",
      component: marketcheckproduct,
      meta: {
        requiresAuth: true
      }
    },

    // marketmanager
    {
      path: "/marketmanager/checkerproduct",
      name: "marketmanagercheckerproduct",
      component: marketmanagercheckerproduct,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/marketmanager/rider",
      name: "marketmanagerrider",
      component: marketmanagerrider,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/marketmanager/recommendproduct",
      name: "marketrecommendproduct",
      component: marketrecommendproduct,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/marketpurchaser",
      name: "marketpurchaser",
      component: marketpurchaser,
      meta: {
        requiresAuth: true
      }
    },
    
    {
      path: "/marketpurchaser/statement",
      name: "marketpurchaserstatement",
      component: marketpurchaserstatement,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/account",
      name: "account",
      component: account,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/account/market",
      name: "accountmarket",
      component: accountmarket,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/account/marketcheck",
      name: "accountmarketcheck",
      component: accountmarketcheck,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/account-stock/marketcheck",
      name: "accountstockmarketcheck",
      component: accountstockmarketcheck,
      meta: {
        requiresAuth: true
      }
    },

    // start issue

    {
      path: "/issue",
      name: "issue",
      component: issue,
      meta: {
        requiresAuth: true
      }
    },

    // end issue

    //ics
    {
      path: "/ics",
      name: "icsmain",
      component: icsmain,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/ics/setting/user",
      name: "icsuser",
      component: icsuser,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/ics/setting/province",
      name: "icsprovince",
      component: icsprovince,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/ics/recorddistrict",
      name: "icsrecorddistrict",
      component: icsrecorddistrict,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/ics/violation",
      name: "icsviolation",
      component: icsviolation,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/ics/certification",
      name: "icscertification",
      component: icscertification,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/ics/groupcheckproduct",
      name: "icsgroupcheckproduct",
      component: icsgroupcheckproduct,
      meta: {
        requiresAuth: true
      }
    },




    // {
    //   path: "/market",
    //   name: "market",
    //   component: market,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },

    // {
    //   path: "/agent",
    //   name: "agent",
    //   component: agent,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },

    // {
    //   path: "/farmer",
    //   name: "farmer",
    //   component: farmer,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },

    // {
    //   path: "/gov",
    //   name: "gov",
    //   component: gov,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },




    {
      path: "*",
      name: "404",
      component: () =>
        import("@/views/notFound.vue")
    }
  ]
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const token = store.get("token");
  if (requiresAuth && !token) {
    next("/login");
  } else if (requiresAuth && token) {
    const exp = store.get("decodedToken@exp");
    const now = new Date().getTime() / 1000; //time in second
    if (exp > now) {
      // const expin = exp - now;
      // if (expin < 60) {
      // } else {
      // }
      next();
    } else {
      Vue.swal({
        type: "error",
        text: "ໝົດເວລາ ນຳໃຊ້ລະບົບ, ກະລຸຸນາ ເຂົ້າລະບົບອີກຄັ້ງ"
      });
      next("/login");
    }
  } else {
    next();
  }
});

export default router;